import { Box, Button, Typography } from "@mui/material";
import LoadingSpinner from "./LoadingSpinner";


const DownloadButton = ({ type, mb }) => {
    return (
        <Box sx={{
            width: '270px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
            mb: mb
        }}>
            <Button sx={{
                width: '208px',
                background: '#20BC71',
                color: '#000',
                borderRadius: 999,
                height: '50px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start',
                pl: '35px',
                "&:hover": {
                    bgcolor: "#111",
                    boxShadow: "none",
                    color: '#fff',
                    border: '1px solid #fff',
                    "& .customIcon": {
                        background: "#fff",
                    }

                },
            }}>
                <Box
                    className="customIcon"
                    sx={{
                        width: '8px',
                        height: '16px',
                        borderTopRightRadius: 999,
                        borderBottomRightRadius: 999,
                        background: '#000',
                        mr: '14px'
                    }} />
                <Typography variant='text' sx={{ textTransform: "lowercase" }}>
                    {type}
                </Typography>
            </Button>
            <LoadingSpinner />
        </Box>
    )
}


export default DownloadButton;